module.exports = "/_next/static/images/6999d81d3c950f71c5b9f546407714cd-credit-card-magic.png";